const CERTIFICATES = [
  {
    path: "/foresters/temp",
    component: "ForestersTemp",
    view: "ForestersTemp",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/temp-revised.png"
  },
  {
    path: "/sed/nursing-training-guide",
    component: "SedNursingTrainingGuide",
    view: "SedNursingTrainingGuide",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/sed.png"
  },
  {
    path: "/foresters/par-fr",
    component: "ForestParFr",
    view: "ForestParFr",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/par-fr.png"
  },
  {
    path: "/foresters/par-en",
    component: "ForestParEn",
    view: "ForestParEn",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/par-en.png"
  },
  {
    path: "/foresters/sales-en",
    component: "ForestersSalesEN",
    view: "ForestersSalesEN",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/sales-en.png"
  },
  {
    path: "/foresters/sales-fr",
    component: "ForestersSalesFR",
    view: "ForestersSalesFR",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/sales-fr.png"
  },
  {
    path: "/foresters/vision-fr",
    component: "ForestVision2020French",
    view: "ForestVision2020French",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/vision2020french.png"
  },
  {
    path: "/foresters/vision-en",
    component: "ForestVision2020English",
    view: "ForestVision2020English",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/canyou.png"
  },
  {
    path: "/foresters/juveniles-en",
    component: "ForestJuvenilesEN",
    view: "ForestJuvenilesEN",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/juv-en-1.png"
  },
  {
    path: "/foresters/juveniles-fr",
    component: "ForestJuvenilesFR",
    view: "ForestJuvenilesFR",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/juv-fr-1.png"
  },
  {
    path: "/wellbeing/1",
    component: "Wellbeing1",
    view: "Wellbeing1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/wellbeing/well.jpg"
  },
  {
    path: "/leadership/naperville",
    component: "LeadershipSurgeNaperville",
    view: "LeadershipSurgeNaperville",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/leadershipsurge/naperville.png"
  },
  {
    path: "/foresters/coverture-fr",
    component: "ForestCovertureFrench",
    view: "ForestCovertureFrench",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/une.png"
  },
  {
    path: "/foresters/estate",
    component: "ForestersEstate",
    view: "ForestersEstate",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/f2.jpg"
  },
  {
    path: "/foresters/better",
    component: "ForestBetter",
    view: "ForestBetter",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/f3.jpg"
  },
  {
    path: "/foresters/opportunity",
    component: "ForestOpportunity",
    view: "ForestOpportunity",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/f4.jpg"
  },
  {
    path: "/foresters/rsg",
    component: "ForestRSG",
    view: "ForestRSG",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/f1.jpg"
  },
  {
    path: "/foresters/3",
    component: "ForestMar25",
    view: "ForestMar25",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/forest_mar25.png"
  },
  {
    path: "/crown/1",
    component: "Crown1",
    view: "Crown1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/crown/crown1.png"
  },
  {
    path: "/cf/1",
    component: "Concussion1",
    view: "Concussion1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/concussionfoundation/cert1.png"
  },
  {
    path: "/uky/1",
    component: "UKY1",
    view: "UKY1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/uky/default.png"
  },
  {
    path: "/crown/2",
    component: "Crown2",
    view: "Crown2",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/crown/crown2.png"
  },
  {
    path: "/foresters/english",
    component: "Feng",
    view: "Feng",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/f-eng.png"
  },
  {
    path: "/foresters/advantage",
    component: "Advantage",
    view: "Forest1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/forest.png"
  },
  {
    path: "/legalwise/june/nz",
    component: "LegalWiseJuneNZ",
    view: "LegalWiseJuneNZ",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/legalwise/nz-june-3.jpg"
  },
  {
    path: "/legalwise/june/aus",
    component: "LegalWiseJuneAUS",
    view: "LegalWiseJuneAUS",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/legalwise/aus-june-3.jpeg"
  },
  {
    path: "/cuservices/1",
    component: "Cuservices",
    view: "Cuservices",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/ceuservicesgroup/dd3.png"
  },
  {
    path: "/cuservices/2",
    component: "Ceu2",
    view: "Ceu2",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/ceuservicesgroup/dd4.png"
  },
  {
    path: "/tmg/1",
    component: "Tmg1",
    view: "Tmg1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/assets/cert_templates/2.png"
  },
  {
    path: "/foresters/french",
    component: "Ffre",
    view: "Ffre",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/f-fre.png"
  },
  {
    path: "/foresters/p1",
    component: "Forp1",
    view: "Forp1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/Forp1.png"
  },
  {
    path: "/foresters/p2",
    component: "Forp2",
    view: "Forp2",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/Forp2.png"
  },
  {
    path: "/toro/1",
    component: "Vlad1",
    view: "Vlad1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/assets/images/certificates/toro.jpg"
  },
  {
    path: "/sightline/1",
    component: "Truman",
    view: "Truman",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/truman/truman.png"
  },
  {
    path: "/vlad/1",
    component: "Vlad1",
    view: "Vlad1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/assets/images/certificates/toro.jpg"
  },
  {
    path: "/gribb/1",
    component: "Gribb1",
    view: "Gribb1",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/gribb/vvr.png"
  },
  {
    path: "/cedeflaw",
    component: "Cedeflaw",
    view: "Cedeflaw",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/cedeflaw/cedeflaw-0.jpg"
  },
  {
    path: "/proliteracy/1",
    component: "proliteracty",
    view: "Proliteracy",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/proliteracy/aug25_1.png"
  },
  {
    path: "/mcico/1",
    component: "mcico",
    view: "mcico",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/mcico/mcico-1.png"
  },
  {
    path: "/vetvine",
    component: "Vetvine",
    view: "Vetvine",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/vetvine/vetvine.png"
  },
  {
    path: "/demo",
    component: "Demo",
    view: "Demo",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/mindstamp/sample.png"
  },
  {
    path: "/cybersafe",
    component: "Cybersafe",
    view: "Cybersafe",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/cybersafe/safe2.png"
  },
  {
    path: "/nebo/transportation",
    component: "Transportation",
    view: "Transportation",
    preview:
      "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/coralee/7.png"
  }
];

const ACRONYMS = {
  aus: "AUS",
  ceu: "CEU",
  cf: "CF",
  en: "EN",
  fr: "FR",
  mcico: "MCICO",
  nz: "NZ",
  rsg: "RSG",
  tmg: "TMG",
  uky: "UKY"
};

function capitalizeWord(word) {
  if (!word) {
    return "";
  }

  const normalized = word.toLowerCase();
  return (
    ACRONYMS[normalized] ||
    normalized.charAt(0).toUpperCase() + normalized.slice(1)
  );
}

function humanizeSegment(segment) {
  if (!segment) {
    return "";
  }

  if (/^\d+$/.test(segment)) {
    return `#${segment}`;
  }

  return segment
    .split("-")
    .map(capitalizeWord)
    .join(" ");
}

export default CERTIFICATES.map(certificate => {
  const segments = certificate.path.replace(/^\//, "").split("/");
  const client = humanizeSegment(segments[0]);
  const section =
    segments
      .slice(1)
      .map(humanizeSegment)
      .join(" / ") || client;

  return {
    ...certificate,
    client,
    title: section,
    searchText: [
      certificate.path,
      certificate.component,
      certificate.view,
      client,
      section
    ]
      .join(" ")
      .toLowerCase()
  };
}).sort((first, second) => first.path.localeCompare(second.path));
